var map = {
	"./TimeFrame-1.png": 3594,
	"./TimeFrame-14.png": 1172,
	"./TimeFrame-16.png": 8998,
	"./TimeFrame-18.png": 9384,
	"./TimeFrame-2.png": 9841,
	"./TimeFrame-3.png": 1448,
	"./TimeFrame-4.png": 1063,
	"./TimeFrame-6.png": 5653,
	"./TimeFrame-8.png": 8043,
	"./TimeFrame.png": 4212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3613;